<bn-loading-overlay></bn-loading-overlay>

<section class="container-fluid acomp-metas">

  <h4 class="mt-3 mb-3 titulo">
    Acompanhamento de Metas de Distribuição de Limites
  </h4>

  <div class="card">

    <div class="card-header">
      Emitir Relatório
    </div>

    <div class="card-body">

      <div class="row align-items-center mb-3">

        <div class="col-auto">
          <label class="form-label me-2 mb-0">
            <b>Analítico:</b>
          </label>

          <input
            type="checkbox"
            [checked]="analitico"
            (change)="selecionarAnalitico()">
        </div>

        <div class="col-auto">
          <label class="form-label me-2 mb-0">
            <b>Sintético:</b>
          </label>

          <input
            type="checkbox"
            [checked]="sintetico"
            (change)="selecionarSintetico()">
        </div>

      </div>

      <button
        type="button"
        class="btn btn-success"
        [disabled]="!podeEmitir"
        (click)="emitir()">

        Emitir

      </button>

    </div>

  </div>

</section>